import { render } from "./press-main.vue?vue&type=template&id=1072e46e&scoped=true"
import script from "./press-main.vue?vue&type=script&lang=js"
export * from "./press-main.vue?vue&type=script&lang=js"

import "./press-main.vue?vue&type=style&index=0&id=1072e46e&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1072e46e"]])

export default __exports__